import { createFileRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getParentByStudioOptions } from '~entities/parent/api/get-parent-by-studio';

import { ParentsListPage } from '~features/parents/ui/parents-list-page';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/parents/')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: ParentsListPage,
  loader: async ({ preload }) => {
    // Preload initial parent data with default parameters
    const params = {
      page: 1,
      limit: 10,
      search: '',
    };

    // Use the same queryOptions that the component will use
    const options = getParentByStudioOptions(params);

    // Preload the data using the queryClient
    await queryClient.ensureQueryData(options);

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
});
